import { Injectable } from '@angular/core';
import { Constants } from './constants';
import { Tags } from './tags';
import { Utils } from './utils';
import { MemoryStorage } from './memory-storage';

@Injectable({
    providedIn: 'root'
})
export class LocalStorage {
    private storage: Storage;
    private sessionStorage: Storage;

    constructor(private constants: Constants, private utils: Utils, private tags: Tags, private memoryStorage: MemoryStorage) {
        this.storage = window.localStorage;
        this.sessionStorage = window.sessionStorage;
    }

    setMemoryKey(keyName: string, keyValue: string) {
        this.memoryStorage.set(keyName, keyValue);
    }

    getMemoryKey(keyName: string) {
        return this.memoryStorage.get(keyName);
    }

    setStorageKey(keyName: string, keyValue: string) {
        this.storage.setItem(keyName, keyValue);
    }

    setSessionStorageKey(keyName: string, keyValue: string) {
        this.sessionStorage.setItem(keyName, keyValue);
    }

    setStorageKey2(keyName: string, keyValue: number): void {
        this.storage.setItem(keyName, keyValue.toString());
    }


    getStorageKey(keyName: string) {
        return this.utils.isEmpty(this.storage.getItem(keyName)) === false ? this.storage.getItem(keyName) : this.constants.BLANK;
    }

    getSessionStorageKey(keyName: string) {
        return this.utils.isEmpty(this.sessionStorage.getItem(keyName)) === false ? this.sessionStorage.getItem(keyName) : this.constants.BLANK;
    }
    removeStorageKey(keyName: string) {
        if (this.utils.isEmpty(this.storage.getItem(keyName)) === false) {
            this.storage.removeItem(keyName);
        }
        this.memoryStorage.remove(keyName);
    }

    removeSessionStorageKey(keyName: string) {
        if (this.utils.isEmpty(this.sessionStorage.getItem(keyName)) === false) {
            this.sessionStorage.removeItem(keyName);
        }
    }

    removeAllStorageData() {
        this.storage.clear();
        this.memoryStorage.clear();
    }

    getApplicationToken(): string {
        return this.getMemoryKey(this.tags.APPLICATION_TOKEN);
    }

    getLoggedUserId() {
        const loggedUserId = this.getMemoryKey(this.tags.LOGGED_USER_ID);
        return this.utils.decryptString(loggedUserId);
    }

    getLoggedUserFullName() {
        const loggedUserFullName = this.getMemoryKey(this.tags.LOGGED_USER_NAME);
        return this.utils.decryptString(loggedUserFullName);
    }

}
